module.exports = __webpack_public_path__ + "static/story2-index-thumbnails-1920x1080-e943c47cada6ed314ec38d8e53055028.jpg";